module.exports = __webpack_public_path__ + "img/3.4af6a500.png";